// ChartCard.js
// The dark card every chart renderer draws on: a header row with the title on
// the left and the chart's actions on the right, then whatever the renderer
// puts beneath. A frame that prints the title itself (a View card) passes
// none, and the row keeps only the actions, hard right.
import React from 'react';
import Box from '@mui/material/Box';

function ChartCard({ title = null, ink, actions = null, children }) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        borderRadius: '12px',
        padding: '16px',
        boxSizing: 'border-box',
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        {title && <h3 style={{ margin: 0, color: ink.primary }}>{title}</h3>}
        <Box display="flex" alignItems="center" ml="auto">
          {actions}
        </Box>
      </Box>
      {children}
    </div>
  );
}

export default ChartCard;
